"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mmSS = exports.getRandomIntInclusive = exports.closeAllDropdowns = exports.openCloseDropdown = exports.updateUTCToUserTZ = exports.hideElement = void 0;
const jstimezonedetect_1 = __importDefault(require("jstimezonedetect"));
const date_fns_tz_1 = require("date-fns-tz");
require("smartbanner.js");
const tz = jstimezonedetect_1.default.determine().name();
const hideElement = (e, hide) => {
    if (hide) {
        e.classList.add('hidden');
    }
    else {
        e.classList.remove('hidden');
    }
};
exports.hideElement = hideElement;
function updateUTCToUserTZ() {
    document.querySelectorAll(".toTZ").forEach((element) => {
        const htmlElement = element;
        const isoDate = htmlElement.dataset.datetime;
        if (!isoDate) {
            return;
        }
        const outputFormat = htmlElement.dataset.format;
        if (!outputFormat) {
            return;
        }
        element.innerHTML = (0, date_fns_tz_1.formatInTimeZone)(new Date(isoDate), tz, outputFormat);
    });
}
exports.updateUTCToUserTZ = updateUTCToUserTZ;
function openCloseDropdown(dropdownBtn) {
    console.debug("openCloseDropdown(" + dropdownBtn.classList.toString() + ")");
    if (dropdownBtn.classList.contains('active')) {
        closeAllDropdowns();
        return;
    }
    closeAllDropdowns();
    dropdownBtn.classList.add('active');
    let sibling = dropdownBtn.nextElementSibling;
    while (sibling) {
        if (sibling.matches('.dropdown-content')) {
            sibling.style.display = 'block';
            break;
        }
        sibling = sibling.nextElementSibling;
    }
}
exports.openCloseDropdown = openCloseDropdown;
function closeAllDropdowns() {
    console.debug("closeAllDropdowns()");
    const dropdowns = document.querySelectorAll('.dropdown-btn.active');
    dropdowns.forEach(dropdown => dropdown.classList.remove('active'));
    const dropdownContents = document.querySelectorAll('.dropdown-content');
    dropdownContents.forEach(content => content.style.display = 'none');
}
exports.closeAllDropdowns = closeAllDropdowns;
function getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
exports.getRandomIntInclusive = getRandomIntInclusive;
function mmSS(duration) {
    // Calculate minutes and seconds
    const minutes = Math.floor(duration / 60);
    const seconds = duration % 60;
    // Format the result as MM:SS
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
exports.mmSS = mmSS;
